import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { I18nService } from 'src/app/shared/services/i18n/i18n.service';
import { Auth0ConfigService } from '../../services/auth0-config.service';
import { GetTenantLinksGQL } from 'src/app/graphql/generated';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  subscription: Subscription = new Subscription();
  contactUsMail!: string;
  tenantTermsLink!: string;
  tenantPrivacyLink!: string;
  tenantContactLink!: string;

  constructor(
    private i18nService: I18nService,
    public translate: TranslateService,
    private readonly authConfigService: Auth0ConfigService,
    private readonly getTenantLinksGQL: GetTenantLinksGQL
  ) {}

  ngOnInit(): void {
    let i18nServiceSubscription = this.i18nService
      .getLanguage()
      .subscribe((language: string) => {
        this.translate.use(language);
      });

    this.subscription.add(i18nServiceSubscription);

    const config = this.authConfigService.getConfig();
    const tenant = config?.tenant || {};

    this.getTenantLinksGQL.fetch().subscribe(({ data }) => {
      const tenantLinks = data?.tenantLinks;
      this.tenantTermsLink =
        tenantLinks?.termsOfUseLink || tenant.termsofUseLink!;
      this.tenantPrivacyLink =
        tenantLinks?.privacyPolicyLink || tenant.privacyPolicyLink!;

      const contactUsLink = tenantLinks?.contactUsLink || config.contactUsMail;
      this.tenantContactLink = `mailto:${contactUsLink}`;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
